var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _polygon2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _path16, _path17, _path18, _path19, _path20, _path21, _rect2, _polygon3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon4, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurple2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.66 94.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18{stroke-width:0px;}.cls-1,.cls-19{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-19{stroke:#de9f7a;stroke-miterlimit:10;}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-8);}.cls-7{fill:url(#linear-gradient-9);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:#565a5b;}.cls-12{fill:#121413;}.cls-13{fill:#242626;}.cls-14{fill:#c58057;}.cls-15{fill:#de9f7a;}.cls-16{fill:#af5c25;}.cls-17{fill:#b067e3;}.cls-18{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.11,
    y1: 7.23,
    x2: 17.02,
    y2: 10.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd9291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd9392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e7b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#efc7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f5d7d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f8e1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fae4e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.87,
    y1: 7.1,
    x2: 43.79,
    y2: 10.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3161.18,
    y1: 2706.27,
    x2: 3167.77,
    y2: 2706.27,
    gradientTransform: "translate(3389.73 2433.32) rotate(-103.89) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3165.78,
    y1: 2706.34,
    x2: 3167.34,
    y2: 2706.38,
    gradientTransform: "translate(3389.73 2433.32) rotate(-103.89) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2183.08,
    y1: -1248.72,
    x2: 2189.67,
    y2: -1248.72,
    gradientTransform: "translate(743.07 2433.32) rotate(-76.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2187.68,
    y1: -1248.65,
    x2: 2189.25,
    y2: -1248.61,
    gradientTransform: "translate(743.07 2433.32) rotate(-76.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 30.52,
    y1: 22.59,
    x2: 30.52,
    y2: 31.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 30.65,
    y1: 7.14,
    x2: 30.65,
    y2: 23.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3988.23,
    y1: 1.04,
    x2: -3987.5,
    y2: 24.73,
    gradientTransform: "translate(-3957.33) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#391909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3b1c0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#442719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#52382e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#634e47"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.46,12.62c-1.23.83-2.42.18-2.69,0-.49-.33-.24-3.39-.24-4.23,0-.15.06-.28.17-.38.18-.17.52-.39,1.04-.4.84-.02,1.89.92,1.89.92l-.17,4.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m42.39,12.62c1.23.83,2.42.18,2.69,0,.49-.33.24-3.39.24-4.23,0-.15-.06-.28-.17-.38-.18-.17-.52-.39-1.04-.4-.84-.02-1.89.92-1.89.92l.17,4.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.66,85.53l5.65-.2.96-15.06c.13-2.05-1.54-3.76-3.59-3.69h0c-1.9.07-3.39,1.64-3.35,3.54l.32,15.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.14,59.32l-6.84,8.19c-1.35,1.62-1.12,4.03.52,5.36h0c1.51,1.22,3.7,1.1,5.06-.28l7.54-7.63c1.57-1.59,1.43-4.19-.31-5.59l-.7-.57c-1.6-1.3-3.95-1.07-5.28.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.07,55.64h17.31v4.05c0,2.36-1.92,4.28-4.28,4.28h-8.74c-2.36,0-4.28-1.92-4.28-4.28v-4.05h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5.14 13.17 4.86 12.03 5.27 11.32 4.86 8.48 4.57 7.3 3.33 7.6 3.42 8.14 2.43 8.28 1.6 8.47 .83 8.74 .87 8.9 .79 8.59 0 8.73 .08 9.38 0 9.98 .85 12.52 1.7 13.01 2.08 14.7 5.31 13.9 5.14 13.17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m4.28,8.86l-.97-.09s-.02,0-.03,0l-.52.45s-.04.01-.05,0l-.3-.22s-.03-.01-.04,0l-.34.14-.34.14s-.01,0-.02,0l-.41-.02s-.02,0-.03,0l-.74.59.81-.48s.02,0,.02,0l.37.04s.02,0,.03,0l.27-.17s0,0,0,0l.3-.1s.02,0,.03,0l.36.22s.03,0,.05,0l.55-.48s.02,0,.03,0l.96-.02Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.04,29.22h0c1.37-.5,2.08-2.02,1.58-3.39l-4.16-12.85-3.84,1.21,2.94,13.13c.35,1.55,1.99,2.45,3.49,1.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m4.75,25.65h0c.55-1.34,2.03-2.03,3.41-1.59l13.56,4.28c2.07.66,3.14,2.94,2.32,4.96h0c-.81,1.96-3.09,2.85-5.01,1.95l-12.88-6.02c-1.34-.63-1.96-2.2-1.39-3.58Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "53.52 13.17 53.8 12.03 53.39 11.32 53.8 8.48 54.09 7.3 55.33 7.6 55.24 8.14 56.22 8.28 57.06 8.47 57.83 8.74 57.79 8.9 57.86 8.59 58.66 8.73 58.58 9.38 58.65 9.98 57.8 12.52 56.96 13.01 56.58 14.7 53.34 13.9 53.52 13.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m54.38,8.86l.97-.09s.02,0,.03,0l.52.45s.04.01.05,0l.3-.22s.03-.01.04,0l.34.14.34.14s.01,0,.02,0l.41-.02s.02,0,.03,0l.74.59-.81-.48s-.02,0-.02,0l-.37.04s-.02,0-.03,0l-.27-.17s0,0,0,0l-.3-.1s-.02,0-.03,0l-.36.22s-.03,0-.05,0l-.55-.48s-.02,0-.03,0l-.96-.02Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m50.61,29.22h0c-1.37-.5-2.08-2.02-1.58-3.39l4.16-12.85,3.84,1.21-2.94,13.13c-.35,1.55-1.99,2.45-3.49,1.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m53.91,25.91h0c-.55-1.34-2.03-2.03-3.41-1.59l-13.56,4.28c-2.07.66-3.14,2.94-2.32,4.96h0c.81,1.96,3.09,2.85,5.01,1.95l12.88-6.02c1.34-.63,1.96-2.2,1.39-3.58Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m17.8,83.95c.94-.03,1.72.71,1.72,1.65.01,1.29.04,3.01.12,4.1.12,1.74.15,4.33.15,4.33,0,0-9.02,1.09-10.96.87,0,0-.03-3.57,3.52-3.98,3.55-.42,4.23-.25,4.23-.25l-.39-4.93c-.07-.94.65-1.76,1.6-1.8h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m19.77,90.93c-.98.79-1.43,1.88-1.63,2.66-.06.23-.1.44-.12.6,1.1-.12,1.83-.21,1.83-.21,0,0,0-.2,0-.52-.01-.58-.03-1.56-.08-2.53Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m17.52,91.48l-.16-4.41-1.05.04.28,3.57s-.68-.17-4.23.25c-.33.04-.63.11-.91.19l.72.81c2.2-1.15,5.34-.45,5.34-.45Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m18.12,93.64c-2.62.18-7.14.47-7.14.47-.09-1.21-.42-1.9-.78-2.28-1.35,1.19-1.34,3.07-1.34,3.07,1.38.16,6.39-.36,9.13-.66,1.1-.12,1.83-.21,1.83-.21,0,0,0-.2,0-.52-.26.03-.89.07-1.7.13Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 13.59,
    y: 83.73,
    width: 7.01,
    height: 2.99
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.94,85.14l-5.65-.2-.96-15.06c-.13-2.05,1.54-3.76,3.59-3.69h0c1.9.07,3.39,1.64,3.35,3.54l-.32,15.41Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.46,58.92l6.84,8.19c1.35,1.62,1.12,4.03-.52,5.36h0c-1.51,1.22-3.7,1.1-5.06-.28l-7.54-7.63c-1.57-1.59-1.43-4.19.31-5.59l.7-.57c1.6-1.3,3.95-1.07,5.28.52Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m43.8,83.56c-.94-.03-1.72.71-1.72,1.65-.01,1.29-.04,3.01-.12,4.1-.12,1.74-.15,4.33-.15,4.33,0,0,9.02,1.09,10.96.87,0,0,.03-3.57-3.52-3.98-3.55-.42-4.23-.25-4.23-.25l.39-4.93c.07-.94-.65-1.76-1.6-1.8h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m41.83,90.54c.98.79,1.43,1.88,1.63,2.66.06.23.1.44.12.6-1.1-.12-1.83-.21-1.83-.21,0,0,0-.2,0-.52.01-.58.03-1.56.08-2.53Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m44.08,91.08l.16-4.41,1.05.04-.28,3.57s.68-.17,4.23.25c.33.04.63.11.91.19l-.72.81c-2.2-1.15-5.34-.45-5.34-.45Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m43.47,93.25c2.62.18,7.14.47,7.14.47.09-1.21.42-1.9.78-2.28,1.35,1.19,1.34,3.07,1.34,3.07-1.38.16-6.39-.36-9.13-.66-1.1-.12-1.83-.21-1.83-.21,0,0,0-.2,0-.52.26.03.89.07,1.7.13Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 41,
    y: 83.34,
    width: 7.01,
    height: 2.99,
    transform: "translate(89.01 169.66) rotate(-180)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "33.37 29.36 27.67 29.36 28.46 21.61 32.58 21.61 33.37 29.36"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m43.21,30.61c.1-1-.33-2.04-1.21-2.53-.29-.16-.6-.27-.94-.31l-7.93-.96s-.19,1.71-2.6,1.71-2.6-1.71-2.6-1.71l-7.93.96c-.34.04-.66.15-.94.31-.88.49-1.32,1.53-1.21,2.53l3.09,28.41h19.34l2.95-28.42Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m30.65,4.72h-10.83c-.73,0-1.33.59-1.33,1.33v8.25c0,2.64,1.48,5.07,3.83,6.28l5.08,2.63c2.04,1.05,4.45,1.05,6.49,0l5.08-2.63c2.35-1.21,3.83-3.64,3.83-6.28V6.05c0-.73-.59-1.33-1.33-1.33h-10.83Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m22.49,27.43s3.5,10.17-2.84,19.86l.23,2.06s11.48-8.54,6.4-22.33c0,0-3.31.16-3.79.4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m39.07,27.43s-3.93,10.22,2.4,19.92l-.21,2.02s-11.06-8.55-5.98-22.34c0,0,3.31.16,3.79.4Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.73,60.58c-1.38.03-1.38,1.71-1.38,1.71v.12s2.77,0,2.77,0v-.18s0-1.68-1.39-1.66Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m29.76,32.63h1.92c4.87,0,8.82,3.95,8.82,8.82v8.97c0,2.51-2.04,4.55-4.55,4.55h-10.45c-2.51,0-4.55-2.04-4.55-4.55v-8.97c0-4.87,3.95-8.82,8.82-8.82Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m23.61,46.02h15.01v5.85c0,.4-.32.72-.72.72h-13.57c-.4,0-.72-.32-.72-.72v-5.85h0Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "23.61 44.83 38.62 44.83 39.06 46.37 23.08 46.37 23.61 44.83"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m28.17,34.23s-.04-3.52,2.13-3.55,2.38,3.24,2.38,3.24l-4.51.31Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.94,7.86c0-.21.04-.42.09-.62l.52-2.02c.49-1.89,2.01-3.34,3.92-3.74L28.18.09c.42-.09.85-.11,1.28-.07l6.62.57c.92.08,1.8.4,2.55.93l3.98,2.81c1.02.72,1.62,1.89,1.62,3.14v11.88c0,.18-.02.35-.07.52,0,0-.72,1.65-2.07,2.49-1.35.84-8.79,3.9-11.5,4.05-2.71.15-11.5-3.49-13.09-5.95-1.58-2.47-.56-12.6-.56-12.6Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple2);
export default __webpack_public_path__ + "static/media/purple_2.66a0654412d1f6ad66c26958ef77b24a.svg";
export { ForwardRef as ReactComponent };